export const checkPathname = (pathname: string): boolean => location.pathname.includes(pathname);
